import {
  GEORLI_SUBGRAPH_URL,
  GET_ACCUMULATED_YIELD,
  GET_BORROWER_ACCOUNT_FOR_LENDER,
  SERVER_BASE_URL,
  SERVER_BASE_URL_PROD,
  YIELD_DISTRIBUTION,
} from "../../constants";
import { getContractName, getNFTImageByContract } from "../../contract";
import {
  FETCH_BORROWED_NFTS,
  FETCH_MARKET_NFT_QUERY,
} from "../../contract/contract-constant";
import { getContractMetadata } from "../../state/action-creators/APIActionCreators";
import fetchApi from "../fetch";
import { getRentedPeriodRemaining } from "../formatters";

export const getBorrowedNfts = async (userAddress) => {
  let responseLentNfts = await fetchApi(
    GEORLI_SUBGRAPH_URL,
    {
      query: FETCH_MARKET_NFT_QUERY(userAddress),
    },
    "post"
  );
  let responseRentNfts = await fetchApi(
    GEORLI_SUBGRAPH_URL,
    {
      query: FETCH_BORROWED_NFTS(userAddress),
    },
    "post"
  );

  console.log(
    "getUserBorrowedNfts response",
    responseLentNfts,
    responseRentNfts
  );

  const allLendedNfts = responseLentNfts.payload.data?.lends;
  const userAllTimeBorrowedNfts = responseRentNfts.payload.data?.rents;

  console.log(
    "getUserBorrowedNfts response",
    allLendedNfts,
    userAllTimeBorrowedNfts
  );
  return { allLendedNfts, userAllTimeBorrowedNfts };
};

export const getKeyForYieldClaim = async (account, type, encrypted) => {
  return await window.ethereum.request({
    method: "personal_sign",
    params: [
      JSON.stringify({
        type,
        encrypted,
      }),
      account,
    ],
  });
};

export const getKeyForYieldClaimLender = async (encPubKey, account) => {
  return await window.ethereum.request({
    method: "eth_decrypt",
    params: [encPubKey, account],
  });
};

export const onYieldDistribution = async (
  key,
  lenderAddress,
  borrowerAddress,
  rewardTokenAddress
) => {
  let body = {
    lenderAddress,
    encryptedPrivateKey: key,
    borrowerAddress,
    rewardTokenAddress,
  };
  console.log("body for yield distribution", body);
  let url = `${SERVER_BASE_URL}${YIELD_DISTRIBUTION}`;

  const resp = await fetchApi(url, body, "post");

  console.log("resp", resp);

  return resp; // parses JSON response into native JavaScript objects

  // return resp;
};

export const getAccumulatedYield = async (
  lenderAddress,
  borrowerAddress,
  rewardTokenAddress
) => {
  let url = `${SERVER_BASE_URL}${GET_ACCUMULATED_YIELD}${lenderAddress.toLowerCase()}/${borrowerAddress.toLowerCase()}/${rewardTokenAddress.toLowerCase()}`;

  const resp = await fetchApi(url);

  console.log("resp", resp);

  return resp.payload; // parses JSON response into native JavaScript objects

  // return resp;
};

export const getBorrowersForLender = async (lenderAddress) => {
  let url = `${SERVER_BASE_URL}${GET_BORROWER_ACCOUNT_FOR_LENDER}${lenderAddress.toLowerCase()}`;

  const resp = await fetchApi(url);

  console.log("resp", resp);

  return resp.payload; // parses JSON response into native JavaScript objects

  // return resp;
};

export const getCollectionWiseNfts = async (nftArray, chainId) => {
  console.log("nftArray", nftArray);

  let collectionAddresses = [...new Set(nftArray.map((nft) => nft.nftAddress))];

  console.log("collectionAddresses", collectionAddresses);

  const collectionsWithMetadata = await Promise.all(
    collectionAddresses.map(async (nft) => {
      return await getContractMetadata(nft, chainId);
    })
  );

  console.log("collectionsWithMetadata", collectionsWithMetadata);

  let collectionWiseNFTs = collectionsWithMetadata.map((collection) => {
    let nfts = [];
    nftArray.forEach((nft) => {
      if (collection.address === nft.nftAddress) {
        nfts.push(nft);
      }
    });
    return {
      ...collection,
      nfts,
    };
  });

  console.log("collectionWiseNFTs", collectionWiseNFTs);
  return collectionWiseNFTs;
};

export const getAllGuilds = async () => {
  try {
    const url = `${SERVER_BASE_URL_PROD}/registration/guilds`;
    const resp = await fetch(url, { method: "get" });
    const responseJSON = await resp.json();

    // .then((response) => {
    console.log("all guilds resp", responseJSON);
    return responseJSON;
    // });
  } catch (e) {
    console.log("error in getSigAndKey", e);
    return false;
  }
};

export const checkForNavigation = async (account) => {
  try {
    const url = `${SERVER_BASE_URL_PROD}/registration/guilds`;
    const resp = await fetch(url, { method: "get" });
    const responseJSON = await resp.json();

    // console.log("all guilds resp", responseJSON);
    const isUserExists = responseJSON.find(
      (user) => user.guildAddress.toLowerCase() === account.toLowerCase()
    );

    if (isUserExists) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    console.log("error in checkForNavigation", e);
    return false;
  }
};

export const getAllScholars = async () => {
  try {
    const url = `${SERVER_BASE_URL_PROD}/registration/scholars`;
    const resp = await fetch(url, { method: "get" });
    const responseJSON = await resp.json();

    // .then((response) => {
    console.log("getAllScholars", responseJSON);
    return responseJSON;
    // });
  } catch (e) {
    console.log("error in getSigAndKey", e);
    return false;
  }
};

export const getTotalTokensStakedFormatted = (payload) => {
  return Number(
    Object.values(payload).reduce(
      (total, val) => Number(val) + Number(total),
      0
    )
  );
};

export const getRentedNftsFromLentNfts = (lentNfts, rentedNfts) => {
  let userRentedNfts = [];

  if (lentNfts.length > 0 && rentedNfts.length > 0) {
    lentNfts.forEach((lentNft) => {
      rentedNfts.forEach((rentedNft) => {
        if (
          lentNft.lendingId === rentedNft.lendingId &&
          getRentedPeriodRemaining(rentedNft.rentedAt, rentedNft.rentDuration) >
            0
        ) {
          userRentedNfts.push({ ...rentedNft });
        }
      });
    });
  }
  return userRentedNfts;
};

export const filterLentNfts = (lentNfts, rentedNfts) => {
  let userLentNfts = [];

  userLentNfts = lentNfts.filter(function (lentNft) {
    return !rentedNfts.some(function (rentedNft) {
      return lentNft.lendingId === rentedNft.lendingId;
    });
  });

  return userLentNfts;
};

export const convertingDataToObjectFormat = (data) => {
  // data.forEach((nft) => (obj[nft.nftAddress] = nft));

  let obj = data.reduce(function (acc, curr) {
    acc[curr.nftAddress] = "";
    return acc;
  }, {});

  return obj;
};

export const removeDuplicateNftsFromArray = (nfts) => {
  return nfts
    .filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.tokenID === value.tokenID && t.nftAddress === value.nftAddress
        )
    )
    .filter(
      (nft) => nft.nftAddress !== "0x9201a886740d193e315f1f1b2b193321d6701d07"
    );
};

export const getNftContractMetadata = async (contractAddress) => {
  try {
    const contractDetails = await getContractName(contractAddress);
    return contractDetails;
  } catch (err) {
    console.log("err", err);
  }
};

export const getNftImages = async (nfts) => {
  try {
    let nftsWithIpfsURIs = await Promise.all(
      nfts.map((nft) => {
        return getNFTImageByContract(nft);
      })
    );

    return nftsWithIpfsURIs;
  } catch (error) {
    console.log(error);
  }
};
export const getUniqueItemsArrayFromTwoArray = (lentNfts, userNfts) => {
  userNfts = userNfts.filter(function (userNft) {
    return !lentNfts.some(function (lentNft) {
      return (
        userNft.nftAddress === lentNft.nftAddress &&
        userNft.tokenID === lentNft.tokenId
        // &&
        // !checkIfNftIsLent(lentNft.lentAt, lentNft.lentDuration)
      );
    });
  });

  return userNfts;
};

export const getCommonItemsArrayFromTwoArray = (lentNfts, userNfts) => {
  userNfts = userNfts.filter(function (userNft) {
    return lentNfts.some(function (lentNft) {
      return userNft.lendingId === lentNft.lendingId;
    });
  });

  return userNfts;
};
